// extracted by mini-css-extract-plugin
export default {"wrapper":"EncounterDuration_wrapper__QcaO2"};